import { requst } from '../config'

// 日历上数据
export const getHseIncidentCalendarApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/hse/incident/listByCalendar?
            startDay=${params.startDay}
            &endDay=${params.endDay}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 字典数据树
export const getIncidentDictTreeApi = dictType => {
    const url = `/system/dict/data/tree?dictType=${dictType}&status=Y`
    return requst.get(url)
}

// 查询日期
export const getIncidentByDateApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/hse/incident/date?
            produceDate=${params.produceDate}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 查询 id
export const getIncidentByIdApi = id => {
    const url = `/monitor/hse/incident/${id}`
    return requst.get(url)
}



// 提交 HseDiary 总结
export const postIncidentCommentApi = commentData => {
    const url = `/monitor/hse/incident`
    return requst.post(url, { ...commentData })
}

// 修改 HseDiary 总结
export const putIncidentCommentApi = (commentData, id) => {
    const url = `/monitor/hse/incident`
    return requst.put(url, { ...commentData, id })
}




